export const EditPromoCodeDatesFormName = 'edit-promo-code-dates';

export enum EditPromoCodeDatesFields {
  ValidFrom = 'validFrom',
  ValidTo = 'validTo',
}
